"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function postAsync(uri, contentType, postBody, authToken) {
    const headerInit = {
        'Content-Type': contentType,
    };
    if (authToken)
        headerInit["Authorization"] = authToken;
    return await fetch(uri, {
        method: 'POST',
        headers: headerInit,
        body: postBody,
    });
}
exports.postAsync = postAsync;
async function patchAsync(uri, contentType, patchBody, authToken) {
    const headerInit = {
        'Content-Type': contentType,
    };
    if (authToken)
        headerInit["Authorization"] = authToken;
    return await fetch(uri, {
        method: 'PATCH',
        headers: new Headers({
            //'Authorization': token,
            'Content-Type': "application/json",
        }),
        body: patchBody,
    });
}
exports.patchAsync = patchAsync;
const exportFunctions = {
    postAsync,
    patchAsync,
};
exports.default = exportFunctions;
//# sourceMappingURL=HttpApiServiceHelper.js.map